import {range} from '@aboutyou/utils';
import React from 'react';

import {Divider, SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import {COINS_HISTORY_PAGE_SIZE} from './hooks/useCoinsHistory';

export const CoinsHistoryPageSkeleton = () => {
  return (
    <SkeletonWrapper>
      {range(0, COINS_HISTORY_PAGE_SIZE).map(id => (
        <>
          <StyledSkeletonBlock key={id} />
          <Divider />
        </>
      ))}
    </SkeletonWrapper>
  );
};

const SkeletonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledSkeletonBlock = styled(SkeletonBlock)`
  height: 6rem;
  margin-bottom: 0;
  border-radius: 1rem;
`;
